import React from 'react'
import { hot } from 'react-hot-loader';
import { Link } from 'react-router-dom';

const FileDetail = (details) => {
  const li_list = details.details.map((detail) => {
    const key = detail[0];
    const value = detail[1];
    return (
      <tr>
        <td>{key}</td>
        <td>{value}</td>
      </tr>
    );
  });

  return (
    <table className='detailTable'>
      {li_list}
    </table>
  );
};

export default hot(module)(FileDetail);
